import {
  LayoutDashboard,
  Users,
  ClipboardList,
  ClipboardCheck,
  MessageSquare,
  BookOpen,
  BarChart2,
  LogOut,
  X,
  Menu,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "population", label: "Analisis Populasi", icon: BarChart2 },
  { id: "users", label: "Daftar Pengguna", icon: Users },
  { id: "epds", label: "Kelola Kuesioner", icon: ClipboardList },
  {
    id: "system-evaluation",
    label: "Kepuasan Sistem",
    icon: ClipboardCheck,
  },
  { id: "messages", label: "Kirim Pesan", icon: MessageSquare },
  { id: "education", label: "Edukasi", icon: BookOpen },
];

export default function Sidebar({
  active,
  onNavigate,
  mobileOpen,
  onMobileToggle,
}) {
  const { user, logout } = useAuth();

  const SidebarContent = () => (
    <div className="flex flex-col h-full">
      {/* Logo */}
      <div className="p-5 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <img
            src="/logo_splash2.png"
            alt="SmartMoms Logo"
            className="w-8 h-8 object-contain"
          />
          <span className="font-display font-800 text-primary-800">
            Smart<span className="text-accent-700">Moms</span>
          </span>
        </div>

        <button
          onClick={onMobileToggle}
          className="lg:hidden text-gray-400 hover:text-gray-600"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Nav */}
      <nav className="flex-1 p-4 space-y-1">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.id}
            onClick={() => {
              onNavigate(item.id);
              if (window.innerWidth < 1024) onMobileToggle();
            }}
            className={`w-full flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-medium transition-all text-left
              ${
                active === item.id
                  ? "bg-primary-800 text-white shadow-sm"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }`}
          >
            <item.icon className="w-4 h-4 flex-shrink-0" />
            {item.label}
          </button>
        ))}
      </nav>

      {/* User info & logout */}
      <div className="p-4 border-t border-gray-100">
        <div className="flex items-center gap-3 mb-3 px-1">
          <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
            <span className="text-xs font-bold text-primary-800">
              {user?.name?.charAt(0) || "A"}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-900 truncate">
              {user?.name}
            </p>
            <p className="text-xs text-gray-400">{user?.role}</p>
          </div>
        </div>
        <button
          onClick={logout}
          className="w-full flex items-center gap-2 px-3.5 py-2.5 rounded-xl text-sm font-medium text-red-500 hover:bg-red-50 transition-colors"
        >
          <LogOut className="w-4 h-4" />
          Keluar
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex flex-col w-60 bg-white border-r border-gray-100 h-screen sticky top-0 flex-shrink-0">
        <SidebarContent />
      </aside>

      {/* Mobile Sidebar Overlay */}
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div
            className="absolute inset-0 bg-black/40"
            onClick={onMobileToggle}
          />
          <aside className="relative w-64 bg-white h-full shadow-xl flex flex-col">
            <SidebarContent />
          </aside>
        </div>
      )}
    </>
  );
}

export function TopBar({ onMobileToggle, title }) {
  return (
    <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-white border-b border-gray-100 px-4 h-14 flex items-center gap-3 shadow-sm">
      <button onClick={onMobileToggle} className="text-gray-600">
        <Menu className="w-5 h-5" />
      </button>
      <div className="flex items-center gap-2">
        <img
          src="/logo_splash2.png"
          alt="SmartMoms Logo"
          className="w-6 h-6 object-contain"
        />
        <span className="font-display font-700 text-primary-800">
          Smart<span className="text-accent-700">Moms</span>
        </span>
      </div>
    </div>
  );
}
